import translate from '../../../locales/en'

const Boolean = (path) => (rowData) =>
  rowData[path] ? translate.Yes : translate.No

export default Boolean
